import { render, staticRenderFns } from "./RegistryRelations.vue?vue&type=template&id=e944710c&"
import script from "./RegistryRelations.vue?vue&type=script&lang=js&"
export * from "./RegistryRelations.vue?vue&type=script&lang=js&"
import style0 from "./RegistryRelations.vue?vue&type=style&index=0&id=e944710c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports